import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Roster from "./components/Roster";
import Seeds from "./components/Seeds";
import HotList from "./components/HotList";
import Faq from "./components/Faq";
import Join from "./components/Join";
import Footer from "./components/Footer";
import Schema from "./components/Schema";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Roster />
        <Seeds />
        <HotList />
        <Faq />
        <Join />
      </main>
      <Footer />
      <Schema />
    </div>
  );
}